import {
  ComponentSize,
  ComponentVariant,
  ComponentAppearance,
} from 'src/modules/shared/types/component.type';

export const cardHoverClasses: Record<ComponentVariant, string> = {
  primary: 'hover:bg-primary-50 hover:shadow-md',
  secondary: 'hover:bg-secondary-50 hover:shadow-md',
  danger: 'hover:bg-danger-50 hover:shadow-md',
  warning: 'hover:bg-warning-50 hover:shadow-md',
  neutral: 'hover:bg-neutral-50 hover:shadow-md',
  success: 'hover:bg-success-50 hover:shadow-md',
  info: 'hover:bg-info-50 hover:shadow-md',
  whatsapp: 'hover:bg-whatsapp-50 hover:shadow-md',
  call: 'hover:bg-call-50 hover:shadow-md',
  email: 'hover:bg-email-50 hover:shadow-md',
};

export const cardSizeClasses: Record<ComponentSize, string> = {
  '2xs': 'p-2',
  xs: 'p-2',
  sm: 'p-3',
  md: 'p-4',
  lg: 'p-6',
};

export const cardBaseClasses = [
  'w-full',
  'rounded-2xl',
  'transition-all',
  'duration-150',
  'border',
  'border-transparent',
  'shadow-sm',
].join(' ');

export const cardFilledClasses: Record<ComponentVariant, string> = {
  primary: 'bg-primary-300 text-white',
  secondary: 'bg-secondary-300 text-white',
  danger: 'bg-danger-300 text-white',
  warning: 'bg-warning-300 text-white',
  neutral: 'bg-neutral-300 text-white',
  success: 'bg-success-300 text-white',
  info: 'bg-info-300 text-white',
  whatsapp: 'bg-whatsapp-300 text-white',
  call: 'bg-call-300 text-white',
  email: 'bg-email-300 text-white',
};

export const cardOutlineClasses: Record<ComponentVariant, string> = {
  primary: 'bg-white border !border-primary-200',
  secondary: 'bg-white border !border-secondary-200',
  danger: 'bg-white border !border-danger-200',
  warning: 'bg-white border !border-warning-200',
  neutral: 'bg-white border !border-neutral-200',
  success: 'bg-white border !border-success-200',
  info: 'bg-white border !border-info-200',
  whatsapp: 'bg-white border !border-whatsapp-200',
  call: 'bg-white border !border-call-200',
  email: 'bg-white border !border-email-200',
};

export const cardSoftClasses: Record<ComponentVariant, string> = {
  primary: 'bg-primary-100 border border-transparent',
  secondary: 'bg-secondary-100 border border-transparent',
  danger: 'bg-danger-100 border border-transparent',
  warning: 'bg-warning-100 border border-transparent',
  neutral: 'bg-neutral-100 border border-transparent',
  success: 'bg-success-100 border border-transparent',
  info: 'bg-info-100 border border-transparent',
  whatsapp: 'bg-whatsapp-100 border border-transparent',
  call: 'bg-call-100 border border-transparent',
  email: 'bg-email-100 border border-transparent',
};

export const cardGhostClasses: Record<ComponentVariant, string> = {
  primary: 'bg-transparent border border-transparent',
  secondary: 'bg-transparent border border-transparent',
  danger: 'bg-transparent border border-transparent',
  warning: 'bg-transparent border border-transparent',
  neutral: 'bg-transparent border border-transparent',
  success: 'bg-transparent border border-transparent',
  info: 'bg-transparent border border-transparent',
  whatsapp: 'bg-transparent border border-transparent',
  call: 'bg-transparent border border-transparent',
  email: 'bg-transparent border border-transparent',
};

export const cardActiveClasses: Record<ComponentVariant, string> = {
  primary: 'active:shadow-md',
  secondary: 'active:shadow-md',
  danger: 'active:shadow-md',
  warning: 'active:shadow-md',
  neutral: 'active:shadow-md',
  success: 'active:shadow-md',
  info: 'active:shadow-md',
  whatsapp: 'active:shadow-md',
  call: 'active:shadow-md',
  email: 'active:shadow-md',
};

export const cardHighlightClasses: Record<
  NonNullable<ComponentAppearance>,
  Record<ComponentVariant, string>
> = {
  outline: {
    primary: 'bg-primary-100 border !border-primary-500',
    secondary: 'bg-secondary-100 border !border-secondary-500',
    danger: 'bg-danger-100 border !border-danger-500',
    warning: 'bg-warning-100 border !border-warning-500',
    neutral: 'bg-neutral-100 border !border-neutral-500',
    success: 'bg-success-100 border !border-success-500',
    info: 'bg-info-100 border !border-info-500',
    whatsapp: 'bg-whatsapp-100 border !border-whatsapp-500',
    call: 'bg-call-100 border !border-call-500',
    email: 'bg-email-100 border !border-email-500',
  },
  soft: {
    primary: 'bg-primary-200 border border-transparent',
    secondary: 'bg-secondary-200 border border-transparent',
    danger: 'bg-danger-200 border border-transparent',
    warning: 'bg-warning-200 border border-transparent',
    neutral: 'bg-neutral-200 border border-transparent',
    success: 'bg-success-200 border border-transparent',
    info: 'bg-info-200 border border-transparent',
    whatsapp: 'bg-whatsapp-200 border border-transparent',
    call: 'bg-call-200 border border-transparent',
    email: 'bg-email-200 border border-transparent',
  },
  filled: {
    primary: 'bg-primary-400 border border-transparent',
    secondary: 'bg-secondary-400 border border-transparent',
    danger: 'bg-danger-400 border border-transparent',
    warning: 'bg-warning-400 border border-transparent',
    neutral: 'bg-neutral-400 border border-transparent',
    success: 'bg-success-400 border border-transparent',
    info: 'bg-info-400 border border-transparent',
    whatsapp: 'bg-whatsapp-400 border border-transparent',
    call: 'bg-call-400 border border-transparent',
    email: 'bg-email-400 border border-transparent',
  },
  ghost: {
    primary: 'bg-primary-50 border !border-primary-100',
    secondary: 'bg-secondary-50 border !border-secondary-100',
    danger: 'bg-danger-50 border !border-danger-100',
    warning: 'bg-warning-50 border !border-warning-100',
    neutral: 'bg-neutral-50 border !border-neutral-100',
    success: 'bg-success-50 border !border-success-100',
    info: 'bg-info-50 border !border-info-100',
    whatsapp: 'bg-whatsapp-50 border !border-whatsapp-100',
    call: 'bg-call-50 border !border-call-100',
    email: 'bg-email-50 border !border-email-100',
  },
};
